module.exports = __webpack_public_path__ + "static/fipcwhiteabc3-4934b7cd7360aa729cd654c9785b6bcf.jpeg";